// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"0ebb9294","348":"e12b13b8","666":"a9393a6b","787":"c93c189c","938":"28e7a17c","943":"9eff3b3b","976":"67be4814"}[chunkId] + ".chunk.js";
};